import { Container, Grid, Typography } from '@mui/material';
import bgFundoLive from '../../assets/bg-other-products-live-revalida.png';
import logoArena from '../../assets/logo-arena-default-2025-1.svg';
import logoTrilhaRevalida from '../../assets/logo-trilha-revalida.svg';
import logoHardworq from '../../assets/logo-hardworq.svg';

import CardOtherProducts from '../cards/CardOtherProducts';

const LIST_OTHER_PRODUCTS = [
	{
		logo: logoArena,
		description: 'A maior preparação para a prova prática do Revalida INEP',
		href: '/',
	},
	{
		logo: logoTrilhaRevalida,
		description: 'A nova preparação extensiva\n' + 'para a prova do Revalida INEP',
		href: '/',
	},
	{
		logo: logoHardworq,
		description: 'O banco de questões do Hardwork Medicina',
		href: '/',
	},
];

export default function OtherProductsSection() {
	return (
		<Grid
			xs={12}
			sx={{
				backgroundImage: `url(${bgFundoLive})`,
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
			}}
		>
			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
				className={'revalida'}
			>
				<Grid
					container
					className={'section'}
					sx={{
						paddingY: 4,
						minHeight: '400px',
					}}
				>
					<Typography
						variant={'h2'}
						fontFamily={'Manrope'}
						color={'#F5F5F5'}
						fontSize={{ xs: '20px', md: '32px' }}
						fontWeight={600}
						lineHeight={1}
					>
						Conheça outros produtos Hardwork
					</Typography>
					<Grid
						item
						container
						flexDirection={{
							xs: 'column',
							md: 'row',
						}}
						flexWrap={'nowrap'}
						justifyContent={'space-between'}
						paddingTop={{ xs: 2, md: 10 }}
						paddingBottom={4}
						gap={4}
					>
						{LIST_OTHER_PRODUCTS?.map((item) => (
							<CardOtherProducts
								description={item?.description}
								logo={item?.logo}
								href={item?.href}
							/>
						))}
					</Grid>
				</Grid>
			</Container>
		</Grid>
	);
}
